import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import MiniDrawer from "./../MiniDrawer";
import { IonButton, IonGrid, IonRow, IonCol, IonItem, IonLabel, IonInput } from '@ionic/react';

import "./Page.css";
import "./../App.css";

import { getTimestamp } from "../components/timeStamp.js";

import { useRecoilState } from "recoil";
import { advisorAtom } from "../atom.js";
import { getLocalStorage } from "../components/localstorage.js";

const Settings = (props) => {

  const [advisor_atom, setAdvisorAtom] = useRecoilState(advisorAtom);
  const [recoilFetched, setRecoilFetched] = useState(false);

  const [arn, setArn] = useState(localStorage.getItem("arn") ?? "");
  const [arnSaving, setArnSaving] = useState(false);

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  useEffect(() => {
    setArn(localStorage.getItem("arn") ?? "");
  }, []);

  useEffect(() => {
    if (JSON.stringify(advisor_atom) === "{}" || !recoilFetched) {
      let userState = getLocalStorage();
      if (!userState.agentToken) {
        localStorage.clear();
        props.history.push("/logout");
      } else {
        setAdvisorAtom(userState);
        setRecoilFetched(true);
      }
    }
  }, [advisor_atom, props.history, recoilFetched, setAdvisorAtom]);

  const saveArn = () => {
    const trimmedArn = (arn ?? "").trim();
    setArnSaving(true);
    fetch(`https://${global.api_url}/agent/updateArn.php?ts=${getTimestamp()}`, {
      method: "POST",
      body: JSON.stringify({ arn: trimmedArn }),
      headers: { token: advisor_atom.agentToken, partnerId: "775dbaef-6ac1-49a1-bfea-9ce82b8dbd2a" },
    })
      .then((res) => res.json())
      .then((json) => {
        setArnSaving(false);
        if (json.status === "success") {
          localStorage.setItem("arn", json.arn ?? trimmedArn);
          props.history.push("/clients");
        } else {
          alert(json.info || "Failed to update ARN");
        }
      })
      .catch(() => {
        setArnSaving(false);
        alert("Failed to update ARN");
      });
  };

  const connectToHmrc = () => {
    const mtd = localStorage.getItem("mtd") || "S";
    const theForm = document.getElementById("agent_connect_form");
    if (!theForm) {
      return;
    }

    theForm.action = `https://${global.api_url}/hmrc/agent_connect.php?env=${mtd}`;

    const w = 450;
    const h = 800;
    const left = window.screen.width / 2 - w / 2;
    const top = window.screen.height / 2 - h / 2;
    const child = window.open(
      "about:blank",
      "Popup_Window",
      "toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0,width=" +
        w +
        ", height=" +
        h +
        ", top = " +
        top +
        ", left = " +
        left
    );

    theForm.target = "Popup_Window";
    theForm.submit();

    let leftDomain = false;
    const interval = setInterval(function () {
      try {
        if (child.document.domain === document.domain) {
          if (leftDomain && child.document.readyState === "complete") {
            clearInterval(interval);
          }
        } else {
          leftDomain = true;
        }
      } catch (e) {
        if (child && child.closed) {
          clearInterval(interval);
          window.location.reload();
          return;
        }
        leftDomain = true;
      }
    }, 500);
  };

  const goToClients = () => {
    setNewPassword("");
    setConfirmPassword("");
    props.history.push("/clients");
  };

  const changePassword = () => {
    if (newPassword === confirmPassword) {
      const body = JSON.stringify({
        email: advisor_atom.username,
        password: advisor_atom.secret,
        newPassword: newPassword,
        confirmPassword: confirmPassword,
      });
      fetch(`https://${global.api_url}/agent/changePassword.php?ts=${getTimestamp()}`, {
        method: "POST",
        body: body,
        headers: { token: advisor_atom.agentToken, partnerId: "775dbaef-6ac1-49a1-bfea-9ce82b8dbd2a" },
      })
        .then((res) => res.json())
        .then((json) => {
          if (json.status === "success") {
            alert("Password changed.");
            setNewPassword("");
            setConfirmPassword("");
          } else {
            alert(json.info);
          }
        });
    } else {
      alert("New password does not match confirm password, please try again");
    }
  };

  const displayMainScreen = () => {
    if (!recoilFetched) return null;
    return (
      <>
        <div
          style={{
            height: 48,
            flexDirection: "row",
            display: "flex",
            paddingLeft: 0,
            paddingBottom: 7,
          }}
        >
          <IonGrid fixed={true} style={{ "--ion-grid-width-md": "600px", "--ion-grid-width-lg": "600px", "--ion-grid-width-xl": "600px" }}>
            {/* ARN section */}
            <IonRow>
              <IonCol>
                <h3 style={{ marginTop: 0 }}>HMRC Agent Reference Number (ARN)</h3>
                <p style={{ marginTop: 0, marginBottom: 8 }}>
                  <a
                    href="https://help.untied.io/article/444-find-your-agent-reference-number-arn-in-hmrc-systems"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ cursor: "pointer" }}
                  >
                    Find your agent reference number (ARN) in HMRC systems
                  </a>
                </p>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol>
                <IonItem>
                  <IonLabel position="floating" className="no-margin-bottom">ARN</IonLabel>
                  <IonInput
                    value={arn}
                    placeholder="e.g. FARN0123456"
                    inputmode="text"
                    onIonChange={(e) => setArn(e.detail.value ?? "")}
                  />
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol>
                <IonButton className="ion-button-money" onClick={saveArn} disabled={arnSaving}>
                  {arnSaving ? "Saving…" : "Save ARN"}
                </IonButton>
                <IonButton
                  className="ion-button-money"
                  style={{ marginLeft: 8, "--box-shadow": "none" }}
                  onClick={connectToHmrc}
                >
                  Connect to HMRC
                </IonButton>
              </IonCol>
            </IonRow>
            <form method="POST" id="agent_connect_form">
              <input type="hidden" name="token" value={advisor_atom.agentToken || ""} />
            </form>

            {/* Change password section */}
            <IonRow style={{ marginTop: 32 }}>
              <IonCol>
                <h3>Change password</h3>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol>
                <IonItem>
                  <IonLabel position="floating" className="no-margin-bottom">New password</IonLabel>
                  <IonInput
                    value={newPassword}
                    placeholder="New password"
                    inputmode="text"
                    type="password"
                    autocomplete="off"
                    autocorrect="off"
                    onIonChange={(e) => setNewPassword(e.detail.value)}
                  />
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol>
                <IonItem>
                  <IonLabel position="floating" className="no-margin-bottom">Confirm password</IonLabel>
                  <IonInput
                    value={confirmPassword}
                    placeholder="Confirm new password"
                    inputmode="text"
                    type="password"
                    autocomplete="off"
                    autocorrect="off"
                    onIonChange={(e) => setConfirmPassword(e.detail.value)}
                  />
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol>
                <IonButton className="ion-button-money" onClick={changePassword}>
                  Set Password
                </IonButton>
              </IonCol>
            </IonRow>
            <IonRow style={{ marginTop: 24 }}>
              <IonCol>
                <IonButton className="ion-button-money" onClick={goToClients}>
                  Close
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </div>
      </>
    );
  };

  return (
    <React.Fragment>
      <div className="accounts-page-container">
        <MiniDrawer />
        <div className="accounts-page-content">{displayMainScreen()}</div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Settings);
